// Mirrors emr-api audit-daily-summary/helpers/subscription-rendering.constants.ts —
// keep in sync so the approve page matches the verification email.
export const OTHER_SERVICE_PREFIXES = [
  "standardLibraryPublicationsPaper",
  "planningStationWeeklyUpdates",
  "planningStationEps",
  "planningStationEpsVas",
  "planningStationEns",
  "eNtmSupport",
  "avcsOptimizationEnc",
] as const;

export type OtherServicePrefix = (typeof OTHER_SERVICE_PREFIXES)[number];

export const OTHER_SERVICE_LABELS: Record<OtherServicePrefix, [string, string]> = {
  standardLibraryPublicationsPaper: [
    "Standard Library Publications",
    "Paper Publications",
  ],
  planningStationWeeklyUpdates: [
    "eMariner Planning Station",
    "AVCS/ADP/eNP Weekly Updates",
  ],
  planningStationEps: [
    "eMariner Planning Station",
    "ENC Viewer, Digital catalogue, A to B",
  ],
  planningStationEpsVas: [
    "eMariner Planning Station",
    "ePS – Value Added Services",
  ],
  planningStationEns: [
    "eMariner Planning Station",
    "eNS – Emergency Navigation System",
  ],
  eNtmSupport: ["eMariner eNTM", "Support Services"],
  avcsOptimizationEnc: ["AVCS Optimization Services", "ENC Optimization"],
};

// Mirrors SERVICES_WITH_PAY_PER_USE_AMOUNT in emr-api's
// subscription-rendering.constants.ts - keep the two in sync.
export const SERVICES_WITH_PAY_PER_USE_AMOUNT = new Set<string>([
  "planningStationWeeklyUpdates",
  "planningStationEps",
  "planningStationEpsVas",
  "planningStationEns",
  "eNtmSupport",
  "avcsOptimizationEnc",
]);
